import React, { useCallback, useState, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { getDashboardNameBySubscriptionUuId } from 'features/scheduledReport/asyncThunks'
import { useAppDispatch } from 'app/hooks'
import { isRejected } from '@reduxjs/toolkit'

import UnsubscribeConfirm from './UnsubscribeConfirm'
import UnsubscribeResult from './UnsubscribeResult'

const useRetrieveDashboardName = (subscriptionUuid?: string | number) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [dashboardName, setDashboardName] = useState('')

  const getDashboardName = useCallback(async () => {
    if (!subscriptionUuid) return
    const res = await dispatch(getDashboardNameBySubscriptionUuId(subscriptionUuid))
    if (isRejected(res)) {
      navigate('.', { state: 'fail' })
    } else {
      setDashboardName(res.payload)
    }
  }, [dispatch, subscriptionUuid, navigate])

  useEffect(() => {
    getDashboardName()
  }, [getDashboardName])

  return dashboardName
}

const Unsubscribe = () => {
  const location = useLocation()
  const { subscriptionUuid } = useParams()
  const dashboardName = useRetrieveDashboardName(subscriptionUuid)

  switch (location.state) {
    case 'success':
    case 'fail':
      return <UnsubscribeResult dashboardName={dashboardName} />
    default:
      return <UnsubscribeConfirm dashboardName={dashboardName} />
  }
}

export default Unsubscribe
